module.exports = __webpack_public_path__ + "img/floor_f11_02.e3274f51.png";